import XLSX from 'xlsx'
export const convertToExcelGST_3 = ({selectedFirm,inwardSupplies,outwardSupplies}) => {
    // export json to Worksheet of Excel
      // only array possible
      let gstSummary = {
        description:'Description of Invoices',
        taxable : 'Total Taxable Value',
        igst : 'IGST A.',
        cgst : 'CGST A.',
        sgst : 'SGST A.',
        cess  :'CESS',
        totalAmount : 'Total Invoices',
      }

      let firmHeader = {
        name : 'Name',
        address : 'Address',
        mobileNumber : 'Mobile',
        panNumber : 'PAN Number',
        email : 'Email',
        GST_number : 'GST Number',
        website : 'Website'
      };

      let firmData = [firmHeader, 
        {
          name : selectedFirm.name,
          address : selectedFirm.address,
          mobileNumber : selectedFirm.mobileNumber,
          panNumber : selectedFirm.panNumber,
          email : selectedFirm.email,
          GST_number : selectedFirm.GST_number,
          website : selectedFirm.website
        }
      ];

      let gstSummaryData = [gstSummary]

      gstSummaryData.push({
        description: 'OUTWARD SUPPLIES',
        taxable : outwardSupplies.totalBaseAmount,
        igst : outwardSupplies.IGST,
        cgst : outwardSupplies.CGST,
        sgst : outwardSupplies.SGST,
        cess  :outwardSupplies.CESS,
        totalAmount : outwardSupplies.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(A). Intra state',
        taxable : outwardSupplies.intraState.totalBaseAmount,
        igst : outwardSupplies.intraState.IGST,
        cgst : outwardSupplies.intraState.CGST,
        sgst : outwardSupplies.intraState.SGST,
        cess  :outwardSupplies.intraState.CESS,
        totalAmount : outwardSupplies.intraState.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(i). Taxable',
        taxable : outwardSupplies.intraState.taxable.totalBaseAmount,
        igst : outwardSupplies.intraState.taxable.IGST,
        cgst : outwardSupplies.intraState.taxable.CGST,
        sgst : outwardSupplies.intraState.taxable.SGST,
        cess  :outwardSupplies.intraState.taxable.CESS,
        totalAmount : outwardSupplies.intraState.taxable.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 0%',
        taxable : outwardSupplies.intraState.taxable.GST_0.totalBaseAmount,
        igst : outwardSupplies.intraState.taxable.GST_0.IGST,
        cgst : outwardSupplies.intraState.taxable.GST_0.CGST,
        sgst : outwardSupplies.intraState.taxable.GST_0.SGST,
        cess  :outwardSupplies.intraState.taxable.GST_0.CESS,
        totalAmount : outwardSupplies.intraState.taxable.GST_0.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 5%',
        taxable : outwardSupplies.intraState.taxable.GST_5.totalBaseAmount,
        igst : outwardSupplies.intraState.taxable.GST_5.IGST,
        cgst : outwardSupplies.intraState.taxable.GST_5.CGST,
        sgst : outwardSupplies.intraState.taxable.GST_5.SGST,
        cess  :outwardSupplies.intraState.taxable.GST_5.CESS,
        totalAmount : outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 12%',
        taxable : outwardSupplies.intraState.taxable.GST_12.totalBaseAmount,
        igst : outwardSupplies.intraState.taxable.GST_12.IGST,
        cgst : outwardSupplies.intraState.taxable.GST_12.CGST,
        sgst : outwardSupplies.intraState.taxable.GST_12.SGST,
        cess  :outwardSupplies.intraState.taxable.GST_12.CESS,
        totalAmount : outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 18%',
        taxable : outwardSupplies.intraState.taxable.GST_18.totalBaseAmount,
        igst : outwardSupplies.intraState.taxable.GST_18.IGST,
        cgst : outwardSupplies.intraState.taxable.GST_18.CGST,
        sgst : outwardSupplies.intraState.taxable.GST_18.SGST,
        cess  :outwardSupplies.intraState.taxable.GST_18.CESS,
        totalAmount : outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: 'GST 28%',
        taxable : outwardSupplies.intraState.taxable.GST_28.totalBaseAmount,
        igst : outwardSupplies.intraState.taxable.GST_28.IGST,
        cgst : outwardSupplies.intraState.taxable.GST_28.CGST,
        sgst : outwardSupplies.intraState.taxable.GST_28.SGST,
        cess  :outwardSupplies.intraState.taxable.GST_28.CESS,
        totalAmount : outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount,
      });


      gstSummaryData.push({
        description: '(ii). Exempted',
        taxable : outwardSupplies.intraState.exempted.totalBaseAmount,
        igst : outwardSupplies.intraState.exempted.IGST,
        cgst : outwardSupplies.intraState.exempted.CGST,
        sgst : outwardSupplies.intraState.exempted.SGST,
        cess  :outwardSupplies.intraState.exempted.CESS,
        totalAmount : outwardSupplies.intraState.exempted.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(iii). Nill Rated',
        taxable : outwardSupplies.intraState.nillrated.totalBaseAmount,
        igst : outwardSupplies.intraState.nillrated.IGST,
        cgst : outwardSupplies.intraState.nillrated.CGST,
        sgst : outwardSupplies.intraState.nillrated.SGST,
        cess  :outwardSupplies.intraState.nillrated.CESS,
        totalAmount : outwardSupplies.intraState.nillrated.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(iv). Others',
        taxable : outwardSupplies.intraState.others.totalBaseAmount,
        igst : outwardSupplies.intraState.others.IGST,
        cgst : outwardSupplies.intraState.others.CGST,
        sgst : outwardSupplies.intraState.others.SGST,
        cess  :outwardSupplies.intraState.others.CESS,
        totalAmount : outwardSupplies.intraState.others.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(A). Inter state',
        taxable : outwardSupplies.interState.totalBaseAmount,
        igst : outwardSupplies.interState.IGST,
        cgst : outwardSupplies.interState.CGST,
        sgst : outwardSupplies.interState.SGST,
        cess  :outwardSupplies.interState.CESS,
        totalAmount : outwardSupplies.interState.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(i). Taxable',
        taxable : outwardSupplies.interState.taxable.totalBaseAmount,
        igst : outwardSupplies.interState.taxable.IGST,
        cgst : outwardSupplies.interState.taxable.CGST,
        sgst : outwardSupplies.interState.taxable.SGST,
        cess  :outwardSupplies.interState.taxable.CESS,
        totalAmount : outwardSupplies.interState.taxable.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: 'GST 0%',
        taxable : outwardSupplies.interState.taxable.GST_0.totalBaseAmount,
        igst : outwardSupplies.interState.taxable.GST_0.IGST,
        cgst : outwardSupplies.interState.taxable.GST_0.CGST,
        sgst : outwardSupplies.interState.taxable.GST_0.SGST,
        cess  :outwardSupplies.interState.taxable.GST_0.CESS,
        totalAmount : outwardSupplies.interState.taxable.GST_0.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 5%',
        taxable : outwardSupplies.interState.taxable.GST_5.totalBaseAmount,
        igst : outwardSupplies.interState.taxable.GST_5.IGST,
        cgst : outwardSupplies.interState.taxable.GST_5.CGST,
        sgst : outwardSupplies.interState.taxable.GST_5.SGST,
        cess  :outwardSupplies.interState.taxable.GST_5.CESS,
        totalAmount : outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 12%',
        taxable : outwardSupplies.interState.taxable.GST_12.totalBaseAmount,
        igst : outwardSupplies.interState.taxable.GST_12.IGST,
        cgst : outwardSupplies.interState.taxable.GST_12.CGST,
        sgst : outwardSupplies.interState.taxable.GST_12.SGST,
        cess  :outwardSupplies.interState.taxable.GST_12.CESS,
        totalAmount : outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 18%',
        taxable : outwardSupplies.interState.taxable.GST_18.totalBaseAmount,
        igst : outwardSupplies.interState.taxable.GST_18.IGST,
        cgst : outwardSupplies.interState.taxable.GST_18.CGST,
        sgst : outwardSupplies.interState.taxable.GST_18.SGST,
        cess  :outwardSupplies.interState.taxable.GST_18.CESS,
        totalAmount : outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 28%',
        taxable : outwardSupplies.interState.taxable.GST_28.totalBaseAmount,
        igst : outwardSupplies.interState.taxable.GST_28.IGST,
        cgst : outwardSupplies.interState.taxable.GST_28.CGST,
        sgst : outwardSupplies.interState.taxable.GST_28.SGST,
        cess  :outwardSupplies.interState.taxable.GST_28.CESS,
        totalAmount : outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(ii). Exempted',
        taxable : outwardSupplies.interState.exempted.totalBaseAmount,
        igst : outwardSupplies.interState.exempted.IGST,
        cgst : outwardSupplies.interState.exempted.CGST,
        sgst : outwardSupplies.interState.exempted.SGST,
        cess  :outwardSupplies.interState.exempted.CESS,
        totalAmount : outwardSupplies.interState.exempted.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(iii). Nill Rated',
        taxable : outwardSupplies.interState.nillrated.totalBaseAmount,
        igst : outwardSupplies.interState.nillrated.IGST,
        cgst : outwardSupplies.interState.nillrated.CGST,
        sgst : outwardSupplies.interState.nillrated.SGST,
        cess  :outwardSupplies.interState.nillrated.CESS,
        totalAmount : outwardSupplies.interState.nillrated.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(iv). Others',
        taxable : outwardSupplies.interState.others.totalBaseAmount,
        igst : outwardSupplies.interState.others.IGST,
        cgst : outwardSupplies.interState.others.CGST,
        sgst : outwardSupplies.interState.others.SGST,
        cess  :outwardSupplies.interState.others.CESS,
        totalAmount : outwardSupplies.interState.others.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: 'INWARD SUPPLIES',
        taxable : inwardSupplies.totalBaseAmount,
        igst : inwardSupplies.IGST,
        cgst : inwardSupplies.CGST,
        sgst : inwardSupplies.SGST,
        cess  :inwardSupplies.CESS,
        totalAmount : inwardSupplies.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(A). Intra state',
        taxable : inwardSupplies.intraState.totalBaseAmount,
        igst : inwardSupplies.intraState.IGST,
        cgst : inwardSupplies.intraState.CGST,
        sgst : inwardSupplies.intraState.SGST,
        cess  :inwardSupplies.intraState.CESS,
        totalAmount : inwardSupplies.intraState.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(i). Taxable',
        taxable : inwardSupplies.intraState.taxable.totalBaseAmount,
        igst : inwardSupplies.intraState.taxable.IGST,
        cgst : inwardSupplies.intraState.taxable.CGST,
        sgst : inwardSupplies.intraState.taxable.SGST,
        cess  :inwardSupplies.intraState.taxable.CESS,
        totalAmount : inwardSupplies.intraState.taxable.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: 'GST 0%',
        taxable : inwardSupplies.intraState.taxable.GST_0.totalBaseAmount,
        igst : inwardSupplies.intraState.taxable.GST_0.IGST,
        cgst : inwardSupplies.intraState.taxable.GST_0.CGST,
        sgst : inwardSupplies.intraState.taxable.GST_0.SGST,
        cess  :inwardSupplies.intraState.taxable.GST_0.CESS,
        totalAmount : inwardSupplies.intraState.taxable.GST_0.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 5%',
        taxable : inwardSupplies.intraState.taxable.GST_5.totalBaseAmount,
        igst : inwardSupplies.intraState.taxable.GST_5.IGST,
        cgst : inwardSupplies.intraState.taxable.GST_5.CGST,
        sgst : inwardSupplies.intraState.taxable.GST_5.SGST,
        cess  :inwardSupplies.intraState.taxable.GST_5.CESS,
        totalAmount : inwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 12%',
        taxable : inwardSupplies.intraState.taxable.GST_12.totalBaseAmount,
        igst : inwardSupplies.intraState.taxable.GST_12.IGST,
        cgst : inwardSupplies.intraState.taxable.GST_12.CGST,
        sgst : inwardSupplies.intraState.taxable.GST_12.SGST,
        cess  :inwardSupplies.intraState.taxable.GST_12.CESS,
        totalAmount : inwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 18%',
        taxable : inwardSupplies.intraState.taxable.GST_18.totalBaseAmount,
        igst : inwardSupplies.intraState.taxable.GST_18.IGST,
        cgst : inwardSupplies.intraState.taxable.GST_18.CGST,
        sgst : inwardSupplies.intraState.taxable.GST_18.SGST,
        cess  :inwardSupplies.intraState.taxable.GST_18.CESS,
        totalAmount : inwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 28%',
        taxable : inwardSupplies.intraState.taxable.GST_28.totalBaseAmount,
        igst : inwardSupplies.intraState.taxable.GST_28.IGST,
        cgst : inwardSupplies.intraState.taxable.GST_28.CGST,
        sgst : inwardSupplies.intraState.taxable.GST_28.SGST,
        cess  :inwardSupplies.intraState.taxable.GST_28.CESS,
        totalAmount : inwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount,
      });


      gstSummaryData.push({
        description: '(ii). Exempted',
        taxable : inwardSupplies.intraState.exempted.totalBaseAmount,
        igst : inwardSupplies.intraState.exempted.IGST,
        cgst : inwardSupplies.intraState.exempted.CGST,
        sgst : inwardSupplies.intraState.exempted.SGST,
        cess  :inwardSupplies.intraState.exempted.CESS,
        totalAmount : inwardSupplies.intraState.exempted.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(iii). Nill Rated',
        taxable : inwardSupplies.intraState.nillrated.totalBaseAmount,
        igst : inwardSupplies.intraState.nillrated.IGST,
        cgst : inwardSupplies.intraState.nillrated.CGST,
        sgst : inwardSupplies.intraState.nillrated.SGST,
        cess  :inwardSupplies.intraState.nillrated.CESS,
        totalAmount : inwardSupplies.intraState.nillrated.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(iv). Others',
        taxable : inwardSupplies.intraState.others.totalBaseAmount,
        igst : inwardSupplies.intraState.others.IGST,
        cgst : inwardSupplies.intraState.others.CGST,
        sgst : inwardSupplies.intraState.others.SGST,
        cess  :inwardSupplies.intraState.others.CESS,
        totalAmount : inwardSupplies.intraState.others.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(A). Inter state',
        taxable : inwardSupplies.interState.totalBaseAmount,
        igst : inwardSupplies.interState.IGST,
        cgst : inwardSupplies.interState.CGST,
        sgst : inwardSupplies.interState.SGST,
        cess  :inwardSupplies.interState.CESS,
        totalAmount : inwardSupplies.interState.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(i). Taxable',
        taxable : inwardSupplies.interState.taxable.totalBaseAmount,
        igst : inwardSupplies.interState.taxable.IGST,
        cgst : inwardSupplies.interState.taxable.CGST,
        sgst : inwardSupplies.interState.taxable.SGST,
        cess  :inwardSupplies.interState.taxable.CESS,
        totalAmount : inwardSupplies.interState.taxable.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: 'GST 0%',
        taxable : inwardSupplies.interState.taxable.GST_0.totalBaseAmount,
        igst : inwardSupplies.interState.taxable.GST_0.IGST,
        cgst : inwardSupplies.interState.taxable.GST_0.CGST,
        sgst : inwardSupplies.interState.taxable.GST_0.SGST,
        cess  :inwardSupplies.interState.taxable.GST_0.CESS,
        totalAmount : inwardSupplies.interState.taxable.GST_0.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 5%',
        taxable : inwardSupplies.interState.taxable.GST_5.totalBaseAmount,
        igst : inwardSupplies.interState.taxable.GST_5.IGST,
        cgst : inwardSupplies.interState.taxable.GST_5.CGST,
        sgst : inwardSupplies.interState.taxable.GST_5.SGST,
        cess  :inwardSupplies.interState.taxable.GST_5.CESS,
        totalAmount : inwardSupplies.interState.taxable.GST_5.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 12%',
        taxable : inwardSupplies.interState.taxable.GST_12.totalBaseAmount,
        igst : inwardSupplies.interState.taxable.GST_12.IGST,
        cgst : inwardSupplies.interState.taxable.GST_12.CGST,
        sgst : inwardSupplies.interState.taxable.GST_12.SGST,
        cess  :inwardSupplies.interState.taxable.GST_12.CESS,
        totalAmount : inwardSupplies.interState.taxable.GST_12.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 18%',
        taxable : inwardSupplies.interState.taxable.GST_18.totalBaseAmount,
        igst : inwardSupplies.interState.taxable.GST_18.IGST,
        cgst : inwardSupplies.interState.taxable.GST_18.CGST,
        sgst : inwardSupplies.interState.taxable.GST_18.SGST,
        cess  :inwardSupplies.interState.taxable.GST_18.CESS,
        totalAmount : inwardSupplies.interState.taxable.GST_18.totalInvoiceAmount,
      });

      
      gstSummaryData.push({
        description: 'GST 28%',
        taxable : inwardSupplies.interState.taxable.GST_28.totalBaseAmount,
        igst : inwardSupplies.interState.taxable.GST_28.IGST,
        cgst : inwardSupplies.interState.taxable.GST_28.CGST,
        sgst : inwardSupplies.interState.taxable.GST_28.SGST,
        cess  :inwardSupplies.interState.taxable.GST_28.CESS,
        totalAmount : inwardSupplies.interState.taxable.GST_28.totalInvoiceAmount,
      });      

      gstSummaryData.push({
        description: '(ii). Exempted',
        taxable : inwardSupplies.interState.exempted.totalBaseAmount,
        igst : inwardSupplies.interState.exempted.IGST,
        cgst : inwardSupplies.interState.exempted.CGST,
        sgst : inwardSupplies.interState.exempted.SGST,
        cess  :inwardSupplies.interState.exempted.CESS,
        totalAmount : inwardSupplies.interState.exempted.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(iii). Nill Rated',
        taxable : inwardSupplies.interState.nillrated.totalBaseAmount,
        igst : inwardSupplies.interState.nillrated.IGST,
        cgst : inwardSupplies.interState.nillrated.CGST,
        sgst : inwardSupplies.interState.nillrated.SGST,
        cess  :inwardSupplies.interState.nillrated.CESS,
        totalAmount : inwardSupplies.interState.nillrated.totalInvoiceAmount,
      });

      gstSummaryData.push({
        description: '(iv). Others',
        taxable : inwardSupplies.interState.others.totalBaseAmount,
        igst : inwardSupplies.interState.others.IGST,
        cgst : inwardSupplies.interState.others.CGST,
        sgst : inwardSupplies.interState.others.SGST,
        cess  :inwardSupplies.interState.others.CESS,
        totalAmount : inwardSupplies.interState.others.totalInvoiceAmount,
      });


      let gstr3Header = {
        sNo : 'S. No',
        description : 'Description',
        placeOfSupply : "Place of Supply",
        taxable : "Taxable Value",
        igst : 'IGST A.',
        cgst : 'CGST A.',
        sgst : 'SGST A.',
        cess  :'CESS',
        totalAmount : 'Total Invoices',
      };

      let gstr3Data = [gstr3Header];

      gstr3Data.push({
        sNo : '3.1',
        description : 'OUTWARD & INWARD SUPPLIES',
        placeOfSupply : "-",
        taxable : inwardSupplies.totalBaseAmount + outwardSupplies.totalBaseAmount,
        igst : inwardSupplies.IGST + outwardSupplies.IGST,
        cgst : inwardSupplies.CGST + outwardSupplies.CGST,
        sgst : inwardSupplies.SGST + outwardSupplies.SGST,
        cess  :inwardSupplies.CESS + outwardSupplies.CESS,
        totalAmount : inwardSupplies.totalInvoiceAmount + outwardSupplies.totalInvoiceAmount,
      });

      gstr3Data.push({
        sNo : '',
        description : '(A). Outward Taxable Supplies [Taxable]',
        placeOfSupply : "-",
        taxable : outwardSupplies.interState.taxable.totalBaseAmount + outwardSupplies.intraState.taxable.totalBaseAmount,
        igst : outwardSupplies.interState.taxable.IGST + outwardSupplies.intraState.taxable.IGST,
        cgst : outwardSupplies.interState.taxable.CGST + outwardSupplies.intraState.taxable.CGST,
        sgst : outwardSupplies.interState.taxable.SGST + outwardSupplies.intraState.taxable.SGST,
        cess  :outwardSupplies.interState.taxable.CESS + outwardSupplies.intraState.taxable.CESS,
        totalAmount : outwardSupplies.interState.taxable.totalInvoiceAmount + outwardSupplies.intraState.taxable.totalInvoiceAmount,
      });

      gstr3Data.push({
        sNo : '',
        description : '(B). Outward Taxable Supplies [Zero Rated]',
        placeOfSupply : "-",
        taxable : outwardSupplies.interState.nillrated.totalBaseAmount + outwardSupplies.intraState.nillrated.totalBaseAmount,
        igst : outwardSupplies.interState.nillrated.IGST + outwardSupplies.intraState.nillrated.IGST,
        cgst : outwardSupplies.interState.nillrated.CGST + outwardSupplies.intraState.nillrated.CGST,
        sgst : outwardSupplies.interState.nillrated.SGST + outwardSupplies.intraState.nillrated.SGST,
        cess  :outwardSupplies.interState.nillrated.CESS + outwardSupplies.intraState.nillrated.CESS,
        totalAmount : outwardSupplies.interState.nillrated.totalInvoiceAmount + outwardSupplies.intraState.nillrated.totalInvoiceAmount,
      });

      gstr3Data.push({
        sNo : '',
        description : '(C). Outward Taxable Supplies [Nill Rated or Exempt]',
        placeOfSupply : "-",
        taxable : outwardSupplies.interState.exempted.totalBaseAmount + outwardSupplies.intraState.exempted.totalBaseAmount,
        igst : outwardSupplies.interState.exempted.IGST + outwardSupplies.intraState.exempted.IGST,
        cgst : outwardSupplies.interState.exempted.CGST + outwardSupplies.intraState.exempted.CGST,
        sgst : outwardSupplies.interState.exempted.SGST + outwardSupplies.intraState.exempted.SGST,
        cess  :outwardSupplies.interState.exempted.CESS + outwardSupplies.intraState.exempted.CESS,
        totalAmount : outwardSupplies.interState.exempted.totalInvoiceAmount + outwardSupplies.intraState.exempted.totalInvoiceAmount,
      });

      gstr3Data.push({
        sNo : '',
        description : '(D). Inward Taxable Supplies [Liable To Reverse Charge]',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  :0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(E). NON-GST Outward Supplies',
        placeOfSupply : "-",
        taxable : outwardSupplies.interState.others.totalBaseAmount + outwardSupplies.intraState.others.totalBaseAmount,
        igst : outwardSupplies.interState.others.IGST + outwardSupplies.intraState.others.IGST,
        cgst : outwardSupplies.interState.others.CGST + outwardSupplies.intraState.others.CGST,
        sgst : outwardSupplies.interState.others.SGST + outwardSupplies.intraState.others.SGST,
        cess  :outwardSupplies.interState.others.CESS + outwardSupplies.intraState.others.CESS,
        totalAmount : outwardSupplies.interState.others.totalInvoiceAmount + outwardSupplies.intraState.others.totalInvoiceAmount,
      });

      gstr3Data.push({
        sNo : '3.2',
        description : 'INTER-STATE Supplies Made To Understand Composition Taxable Persons UIN Holders',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '4',
        description : 'ELIGIABLE ITC',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(A). ITC Available [Full/Part]',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(i). Imports of Goods',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(ii). Imports of Services',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(iii). Inward Supplies Liable To reverse charges',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(iv). Inward Supplies From ISD',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(v). All Other ITC',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(B). ITC Reserved',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(i). As per Rules 42 & 43 of cost',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(ii). Others',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(C). Net ITC Available (A) - (B)',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(D). InEligible ITC',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(i). As per Section 17(s)',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(ii). Others',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '5',
        description : 'Values Of Exempted Nill rated & NON-GST Inward Supplies',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });
      
      gstr3Data.push({
        sNo : '',
        description : '(A). From Supplier Under Composition Scheme, Exempt & Nillrated Supplies',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      gstr3Data.push({
        sNo : '',
        description : '(B). Non-GST Supplies',
        placeOfSupply : "-",
        taxable : 0,
        igst : 0,
        cgst : 0,
        sgst : 0,
        cess  : 0,
        totalAmount : 0,
      });

      
      
      var gstSummaryWS = XLSX.utils.json_to_sheet(gstSummaryData,{skipHeader : true}) 
      var firmWS = XLSX.utils.json_to_sheet(firmData,{skipHeader : true}) 
      var gstr3WS = XLSX.utils.json_to_sheet(gstr3Data,{skipHeader : true}) 

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, gstSummaryWS, 'GST Summary')
      XLSX.utils.book_append_sheet(wb, gstr3WS, 'GSTR-3') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, firmWS, 'Firm')   

      return wb;

      // export Excel file
}


export const convertToExcelGST_1All = ({
  selectedFirm,
  B2B_invoices,
  B2C_invoices_big,
  B2C_invoices_small,
  Nillrated_invoices,
  Export_invoices,
  Adjustment_advance,
  Tax_Liability,
  Credit_Debit_note_reg,
  Credit_Debit_note_unreg,
  HSN_SAC_Summary,
  Document_Summary}) =>{
  var wb = XLSX.utils.book_new() // make Workbook of Excel

  let firmHeader = {
    name : 'Name',
    address : 'Address',
    mobileNumber : 'Mobile',
    panNumber : 'PAN Number',
    email : 'Email',
    GST_number : 'GST Number',
    website : 'Website'
  };

  let firmData = [firmHeader, 
    {
      name : selectedFirm.name,
      address : selectedFirm.address,
      mobileNumber : selectedFirm.mobileNumber,
      panNumber : selectedFirm.panNumber,
      email : selectedFirm.email,
      GST_number : selectedFirm.GST_number,
      website : selectedFirm.website
    }
  ];
  var firmWS = XLSX.utils.json_to_sheet(firmData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, firmWS, 'Firm')  

  let b2bHeader = {
    gstin : 'GSTIN OR UIN',
    invoiceId : 'INVOICE NUMBER',
    date : 'INVOICE DATE',
    totalAmount : 'INVOICE VALUE',
    location : 'PLACE OF SUPPLY',
    revevrseCharge : 'REVERSE CHARGE',
    applicable_tax_rate : 'APPLICABLE % OF TAX RATE',
    type : 'INVOICE TYPE',
    gstin_op : 'GSTIN OF E-COMMERCE OPERATOR',
    s_no:'SERIAL NUMBER',
    rate : 'RATE',
    basicAmount : 'TAXABLE VALUE',
    IGST_val  :'INTEGRATED TAX',
    CGST_val : 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS : 'CESS',
  };

  let b2bData = [b2bHeader, ...B2B_invoices.invoices.map((invoice,index)=>{
    return {
      gstin : invoice.buyer.GST_number, 
      invoiceId : invoice.invoiceId,
      date : new Date(invoice.date).toLocaleDateString('en-GB'),
      totalAmount : invoice.totalAmount,
      location : invoice.buyer.state,
      revevrseCharge : 0,
      applicable_tax_rate : 0,
      type : '-',
      gstin_op : '-',
      s_no:index+1,
      rate : '-',
      basicAmount : invoice.basicAmount,
      IGST_val  :invoice.IGST_val,
      CGST_val : invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS : invoice.CESS,
    }
  })];

  var b2bWS = XLSX.utils.json_to_sheet(b2bData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, b2bWS, 'B2B')  

  //B2C_invoices_big
    let b2clHeader = {
      invoiceId : 'INVOICE NUMBER',
      date : 'INVOICE DATE',
      totalAmount : 'INVOICE VALUE',
      location : 'PLACE OF SUPPLY',
      applicable_tax_rate : 'APPLICABLE % OF TAX RATE',
      gstin_op : 'GSTIN OF E-COMMERCE OPERATOR',
      s_no:'SERIAL NUMBER',
      rate : 'RATE',
      basicAmount : 'TAXABLE VALUE',
      IGST_val  :'INTEGRATED TAX',
      CESS : 'CESS',
    };

  let b2clData = [b2clHeader, ...B2C_invoices_big.invoices.map((invoice,index)=>{
    return {
      invoiceId : invoice.invoiceId,
      date : new Date(invoice.date).toLocaleDateString('en-GB'),
      totalAmount : invoice.totalAmount,
      location : invoice.buyer.state,
      applicable_tax_rate : 0,
      gstin_op : '-',
      s_no:index+1,
      rate : '-',
      basicAmount : invoice.basicAmount,
      IGST_val  :invoice.IGST_val,
      CESS : invoice.CESS,
    }
  })];

  var b2clWS = XLSX.utils.json_to_sheet(b2clData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, b2clWS, 'B2CL')  

  //B2C_invoices_small
  let b2csHeader = {
    type : 'TYPE',
    location : 'PLACE OF SUPPLY',
    supplyType : 'SUPPLY TYPE',
    applicable_tax_rate : 'APPLICABLE % OF TAX RATE',
    gstin_op : 'GSTIN OF E-COMMERCE OPERATOR',
    rate : 'RATE',
    basicAmount : 'TAXABLE VALUE',
    IGST_val  :'INTEGRATED TAX',
    CGST_val : 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS : 'CESS', 
  };

  let b2csData = [b2csHeader, ...B2C_invoices_small.invoices.map((invoice,index)=>{
    return {
      type : '-',
      location : invoice.buyer.state,
      supplyType : '',
      applicable_tax_rate : 0,
      gstin_op : '-',
      rate : '-',
      basicAmount : invoice.basicAmount,
      IGST_val  :invoice.IGST_val,
      CGST_val : invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS : invoice.CESS,  
    }
  })];

  var b2csWS = XLSX.utils.json_to_sheet(b2csData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, b2csWS, 'B2CS')  

   //Nillrated_invoices
  let nillHeader = {
    natureOfSupply : 'NATURE OF SUPPLY',
    nilRatedSupplies : 'NIL RATED SUPPLIES',
    exempted : 'EXEMPTED',
    nonGSTSupplies : 'NON-GST SUPPLIES'
  };

  let nillData = [nillHeader, ...Nillrated_invoices.invoices.map((invoice,index)=>{
    return {
      natureOfSupply : '-',
      nilRatedSupplies : '-',
      exempted : '-',
      nonGSTSupplies : '-'
    }
  })];

  var nillWS = XLSX.utils.json_to_sheet(nillData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, nillWS, 'NIL')  

  //Export_invoices

  let exportHeader = {
    exportType: 'EXPORT TYPE',
    invoiceId : 'INVOICE NUMBER',
    date : 'INVOICE DATE',
    totalAmount : 'INVOICE VALUE',
    shippingBillNo : 'SHIPPING BILL NO. OR BILL OF EXPORT NO.',
    shippingBillDate : 'SHIPPING BILL DATE OR BILL OF EXPORT DATE',
    shippingBillPort : 'SHIPPING BILL PORT CODE',
    applicable_tax_rate : 'APPLICABLE % OF TAX RATE',
    rate : 'RATE',
    basicAmount : 'TAXABLE VALUE',
    IGST_val  :'INTEGRATED TAX',
    CESS : 'CESS',
  }

  let exportData = [exportHeader, ...Export_invoices.invoices.map((invoice,index)=>{
    return {
      exportType: '-',
      invoiceId : invoice.invoiceId,
      date : new Date(invoice.date).toLocaleDateString('en-GB'),
      totalAmount : invoice.totalAmount,
      shippingBillNo : '-',
      shippingBillDate : '-',
      shippingBillPort : '-',
      applicable_tax_rate : 0,
      rate : '-',
      basicAmount : invoice.basicAmount,
      IGST_val  :invoice.IGST_val,
      CESS : invoice.CESS,
    }
  })];

  var exportWS = XLSX.utils.json_to_sheet(exportData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, exportWS, 'EXP')  

  //Adjustment_advance

  var atHeader = {
    location : 'PLACE OF SUPPLY',
    supplyType : 'SUPPLY TYPE',
    applicable_tax_rate : 'APPLICABLE % OF TAX RATE',
    rate : 'RATE',
    grossAdvanceReceived : 'GROSS ADVANCE RECEIVED',
    IGST_val  :'INTEGRATED TAX',
    CGST_val : 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS : 'CESS', 
  }

  let atData = [atHeader, ...Adjustment_advance.invoices.map((invoice,index)=>{
    return {
      location : invoice.buyer.state,
      supplyType : '-',
      applicable_tax_rate : '-',
      rate : '-',
      grossAdvanceReceived : '-',
      IGST_val  :invoice.IGST_val,
      CGST_val : invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS : invoice.CESS,  
    }
  })];

  var atWS = XLSX.utils.json_to_sheet(atData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, atWS, 'AT')  


  //Tax_Liability

  let tlHeader = {
    location : 'PLACE OF SUPPLY',
    supplyType : 'SUPPLY TYPE',
    applicable_tax_rate : 'APPLICABLE % OF TAX RATE',
    rate : 'RATE',
    grossAdvanceReceived : 'GROSS ADVANCE RECEIVED',
    IGST_val  :'INTEGRATED TAX',
    CGST_val : 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS : 'CESS', 
  };

  let tlData = [tlHeader, ...Tax_Liability.invoices.map((invoice,index)=>{
    return {
      location : invoice.buyer.state,
      supplyType : '-',
      applicable_tax_rate : '-',
      rate : '-',
      grossAdvanceReceived : '-',
      IGST_val  :invoice.IGST_val,
      CGST_val : invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS : invoice.CESS,  
    }
  })];

  var tlWS = XLSX.utils.json_to_sheet(tlData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, tlWS, 'TXP')  

  //Credit_Debit_note_reg

  let cdnrHeader = {
    gstin : 'GSTIN OR UIN',
    invoiceId : 'INVOICE NUMBER',
    date : 'INVOICE DATE',
    noteType : 'NOTE TYPE',
    noteNumber : 'NOTE NUMBER',
    noteDate : 'NOTE DATE',
    totalAmount : 'NOTE VALUE',
    preGSTRegime : 'PRE GST REGIME?',
    applicable_tax_rate : 'APPLICABLE % OF TAX RATE',
    s_no:'SERIAL NUMBER',
    rate : 'RATE',
    basicAmount : 'TAXABLE VALUE',
    IGST_val  :'INTEGRATED TAX',
    CGST_val : 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS : 'CESS',
  };

  let cdnrData = [cdnrHeader, ...Credit_Debit_note_reg.invoices.map((invoice,index)=>{
    return {
      gstin : invoice.buyer.GST_number, 
      invoiceId : invoice.invoiceId,
      date : new Date(invoice.date).toLocaleDateString('en-GB'),
      noteType : '-',
      noteNumber : '-',
      noteDate : '-',
      totalAmount : invoice.totalAmount,
      preGSTRegime : '-',
      applicable_tax_rate : 0,
      type : '-',
      gstin_op : '-',
      s_no:index+1,
      rate : '-',
      basicAmount : invoice.basicAmount,
      IGST_val  :invoice.IGST_val,
      CGST_val : invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS : invoice.CESS,
    }
  })];

  var cdnrWS = XLSX.utils.json_to_sheet(cdnrData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, cdnrWS, 'CDNR')  

  //Credit_Debit_note_unreg

  
  let cdnurHeader = {
    counterPartyType : 'COUNTER PARTY TYPE',
    invoiceId : 'INVOICE NUMBER',
    date : 'INVOICE DATE',
    noteType : 'NOTE TYPE',
    noteNumber : 'NOTE NUMBER',
    noteDate : 'NOTE DATE',
    totalAmount : 'NOTE VALUE',
    preGSTRegime : 'PRE GST REGIME?',
    applicable_tax_rate : 'APPLICABLE % OF TAX RATE',
    s_no:'SERIAL NUMBER',
    rate : 'RATE',
    basicAmount : 'TAXABLE VALUE',
    IGST_val  :'INTEGRATED TAX',
    CESS : 'CESS',
  };

  let cdnurData = [cdnurHeader, ...Credit_Debit_note_unreg.invoices.map((invoice,index)=>{
    return {
      counterPartyType : '-', 
      invoiceId : invoice.invoiceId,
      date : new Date(invoice.date).toLocaleDateString('en-GB'),
      noteType : '-',
      noteNumber : '-',
      noteDate : '-',
      totalAmount : invoice.totalAmount,
      preGSTRegime : '-',
      applicable_tax_rate : 0,
      type : '-',
      gstin_op : '-',
      s_no:index+1,
      rate : '-',
      basicAmount : invoice.basicAmount,
      IGST_val  :invoice.IGST_val,
      CESS : invoice.CESS,
    }
  })];

  var cdnurWS = XLSX.utils.json_to_sheet(cdnurData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, cdnurWS, 'CDNUR')  

  //HSN_SAC_Summary 

  let hsnHeader = {
    s_no:'SERIAL NUMBER',
    hsnCode : 'HSN OR SAC CODE',
    desc : 'DESCRIPTION',
    uqc : 'UQC',
    quantity : 'TOTAL QUANTITY',
    totalAmount : 'TOTAL VALUE',
    basicAmount : 'TAXABLE VALUE',
    IGST_val  :'INTEGRATED TAX',
    CGST_val : 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS : 'CESS',

  };

  let hsnData = [hsnHeader, ...HSN_SAC_Summary.invoices.map((invoice,index)=>{
    return {
      s_no:index+1,
      hsnCode : '-',
      desc : '-', 
      counterPartyType : '-', 
      uqc : '-',
      quantity : '-',
      totalAmount : invoice.totalAmount,
      basicAmount : invoice.basicAmount,
      IGST_val  :invoice.IGST_val,
      CGST_val : invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS : invoice.CESS,
    }
  })];

  var hsnWS = XLSX.utils.json_to_sheet(hsnData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, hsnWS, 'HSN')  

  //Document_Summary

  let docHeader = {
    n_doc : 'NATURE OF DOCUMENT',
    s_no:'SERIAL NUMBER',
    from_sr : 'FROM SERIAL NUMBER',
    to_sr : 'TO SERIAL NUMBER',
    totalNo : 'TOTAL NUMBER',
    cancelled : 'CANCELLED',
    netIssued  : 'NET ISSUED',

  };

  let docData = [docHeader, ...Document_Summary.invoices.map((invoice,index)=>{
    return {
      n_doc : '-',
      s_no:index+1,
      from_sr : '-',
      to_sr : '-',
      totalNo : '-',
      cancelled : '-',
      netIssued  : '-',
    }
  })];

  var docWS = XLSX.utils.json_to_sheet(docData,{skipHeader : true}) 
  XLSX.utils.book_append_sheet(wb, docWS, 'DOC_ISSUED')  

  return wb;
}
export const buyerStatementExcel = ({
      selectedFirm,
      invoices}) =>{
      var wb = XLSX.utils.book_new() // make Workbook of Excel
    
      let firmHeader = {
        name : 'Name',
        address : 'Address',
        mobileNumber : 'Mobile',
        panNumber : 'PAN Number',
        email : 'Email',
        GST_number : 'GST Number',
        website : 'Website'
      };
    
      let firmData = [firmHeader, 
        {
          name : selectedFirm.name,
          address : selectedFirm.address,
          mobileNumber : selectedFirm.mobileNumber,
          panNumber : selectedFirm.panNumber,
          email : selectedFirm.email,
          GST_number : selectedFirm.GST_number,
          website : selectedFirm.website
        }
      ];
      var firmWS = XLSX.utils.json_to_sheet(firmData,{skipHeader : true}) 
      XLSX.utils.book_append_sheet(wb, firmWS, 'Info') 
        
      function getVocherType(invoice) {
        if (invoice.return) {
          if (invoice.isBuyer) {
            return "Credit Note";
          } else {
            return "Debit Note";
          }
        } 
        else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "Loan" || invoice["type"] === "Security") {
          return invoice["type"] ;
        } 
        else if (invoice.isBuyer && invoice.transactionType === "Debit") {
          return "Sale";
        }
        else if (invoice.isBuyer && invoice.transactionType === "Credit" || !invoice.isBuyer && invoice.transactionType === "Credit") {
          return "Payment";
        }
        else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
          return "Purchase";
        }
      }
  
      let invoiceHeader = {
        date : 'Date',
        invoiceKey : 'Invoice Key',
        invoiceId : 'Invoice ID',
        debit : 'Debit',
        credit : 'Credit',
        runningBal : 'Running Balance',
        paymentType : 'Payment Type',
        voucherType : 'Voucher Type'
      };
  
      let invoiceData = [invoiceHeader]
      invoices.map((invoice)=>{
        invoiceData.push({
          date : new Date(invoice.date).toLocaleDateString('en-GB'),
          invoiceKey : invoice['.key'],
          invoiceId : invoice['invoiceId'],
          debit : Number.parseFloat(invoice['debit']).toFixed(2),
          credit :  Number.parseFloat(invoice['credit']).toFixed(2),
          runningBal :  Number.parseFloat(invoice['RunningBal']).toFixed(2),
          paymentType : invoice['paymentType'], 
          voucherType : getVocherType(invoice)
        })
      })
  
      var invoiceWS = XLSX.utils.json_to_sheet(invoiceData,{skipHeader : true}) 
      XLSX.utils.book_append_sheet(wb, invoiceWS, 'Invoices')       
  
      return wb;
}


// WEBPACK FOOTER //
// ./src/utils/excelExport.js